/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetOrderResponseDataSpecialServiceRequestsInner } from './getOrderResponseDataSpecialServiceRequestsInner';
import { GetOrderResponseDataTravelDocumentsInner } from './getOrderResponseDataTravelDocumentsInner';
import { GetOrderResponseDataTravelDocumentsSummary } from './getOrderResponseDataTravelDocumentsSummary';
import { MultiCurrencyAirPricingRecords } from './multiCurrencyAirPricingRecords';
import { GetOrderResponseDataLinkedOrdersInner } from './getOrderResponseDataLinkedOrdersInner';
import { GetOrderResponseDataPaymentRecordsInner } from './getOrderResponseDataPaymentRecordsInner';
import { GetOrderResponseDataAir } from './getOrderResponseDataAir';
import { GetOrderResponseDataServices } from './getOrderResponseDataServices';
import { GetOrderResponseDataOrderEligibilities } from './getOrderResponseDataOrderEligibilities';
import { GetOrderResponseDataServicingPointOfSale } from './getOrderResponseDataServicingPointOfSale';
import { GetOrderResponseDataContacts } from './getOrderResponseDataContacts';
import { GetOrderResponseDataSeats } from './getOrderResponseDataSeats';
import { GetOrderResponseDataSpecialKeywordsInner } from './getOrderResponseDataSpecialKeywordsInner';
import { GetOrderResponseDataNextActions } from './getOrderResponseDataNextActions';
import { Contacts } from './contacts';
import { GetOrderResponseDataOrderType } from './getOrderResponseDataOrderType';
import { GetOrderResponseDataServiceSummary } from './getOrderResponseDataServiceSummary';
import { GetOrderResponseDataTravelersSummary } from './getOrderResponseDataTravelersSummary';
import { GetOrderResponseDataMiscAncillariesInner } from './getOrderResponseDataMiscAncillariesInner';
import { Traveler } from './traveler';
import { GetOrderResponseDataPrices } from './getOrderResponseDataPrices';
import { GetOrderResponseDataTasks } from './getOrderResponseDataTasks';

/**
 * PNR情報
 */
export interface GetOrderResponseData {
  /**
   * 予約番号(英数字6桁)
   */
  orderId?: string;
  /**
   * SK LKRLにて紐づけられた関連する予約リスト<br/> ※搭乗者姓名がSK LKRLのフリーテキストに登録されているものをASWにて紐づけされた予約とみなし、その予約のリストを返却する。
   */
  linkedOrders?: Array<GetOrderResponseDataLinkedOrdersInner>;
  /**
   * 購入・発券状態<br/> unpurchased：未購入。特典の減算およびAncillary以外のFPエレメントが何も存在しない<br/> paymentAccepted：支払受付中。特典の減算およびAncillary以外のFPエレメントについて、以下を全て満たすものがある<br/> 1 FPエレメントのFOPコードがWBCASHまたはWCCASHである(DxAPIからはidとして返却されるコード)<br/> 2 払込期限(※)が存在し、現在時刻を過ぎていない<br/> ※ FPのフリーテキストの内容をDxAPIが文字列解析したものが返却され、解析されたパラメータの4番目に払込期限がyyyyMMddHHmmss形式で返却される。<br/> unticketed：未発券。未購入、支払受付中以外で、航空券が発券されているセグメント/搭乗者が1つもない<br/> ticketed：発券済み。上記以外
   */
  orderStatus?: GetOrderResponseData.OrderStatusEnum;
  nextActions?: GetOrderResponseDataNextActions;
  orderEligibilities?: GetOrderResponseDataOrderEligibilities;
  servicingPointOfSale?: GetOrderResponseDataServicingPointOfSale;
  air?: GetOrderResponseDataAir;
  /**
   * 支払情報
   */
  prices?: MultiCurrencyAirPricingRecords;
  /**
   * 積算マイル数（1PAXあたり）<br/> 全てのセグメントがOPEN便でない、かつ販売キャリアがNHグループの場合に返却する。<br/> マイル数は、NHグループ便名のセグメントを対象に基本マイル×マイル積算率にて算出され、その合算値を積算マイル数とする。ただし、対象セグメントの運航キャリアにASWDB(マスタ)の積算マイル表示対象外キャリアを1便でも含んでいた場合、もしくは積算マイル算出に必要な情報が不足している場合には、積算マイル計算不可として、当項目を返却しない。<br/> ※基本マイル：ASWDB(マスタ)より、当該セグメントの出発・到着空港をキーに取得する<br/> ※マイル積算率：<br/>   1 国際線区間の場合<br/>     ASWDB(マスタ)より、当該セグメントのキャリアコードとブッキングクラスをキーに取得する。ただし、NHグループ運航便以外の場合には、ASWDB(マスタ)より、便番号・ブッキングクラスを元に、曜日毎の変換後ブッキングクラスを取得し、変換後のブッキングクラスを用いて積算率を取得する。<br/>   2 国内線区間の場合<br/>     設定ファイルより、当該セグメントのブッキングクラスを元に取得する<br/> ※アップグレード済み、またはアップグレード前のセグメントが存在する場合、下位クラスのセグメントを対象セグメントとする。ただし、PUPG、またはBid My Priceアップグレードの場合、下位クラスを特定できないため、当該PNRの積算マイル合計の算出は不可とし返却しない。<br/> ※運賃表示対象外Fare Basis(設定ファイルに定義)が含まれる場合も算出不可とし、返却しない。
   */
  accuralMiles?: number;
  /**
   * 連絡先情報
   */
  contacts?: Contacts;
  /**
   * 搭乗者情報（幼児含む）リスト
   */
  travelers?: Array<Traveler>;
  /**
   * マイレージプログラム情報
   */
  frequentFlyerCards?: Array<object>;
  /**
   * 搭乗者情報系サポート
   */
  travelerSupports?: object;
  seats?: GetOrderResponseDataSeats;
  services?: GetOrderResponseDataServices;
  orderType?: GetOrderResponseDataOrderType;
  tasks?: GetOrderResponseDataTasks;
  /**
   * DxAPIから返却されたLast Ticketing Date(LTD)
   */
  ticketingDeadline?: string;
  /**
   * コールセンター問い合わせを伴う運賃再計算エラーが発生しているかどうか<br/> DxAPIから運賃再計算ができなかった旨のエラーが返却され、かつ以下のいずれかに該当する場合にtrue<br/> 1.セグメントステータスがUSとなるセグメントが存在<br/> 2.操作日時が運賃の発券期限を過ぎている<br/> 3.TSTが上限の999件である
   */
  isRepricingFailedWithCallCenterContact?: boolean;
  travelersSummary?: GetOrderResponseDataTravelersSummary;
  serviceSummary?: GetOrderResponseDataServiceSummary;
  /**
   * ドキュメント情報リスト
   */
  travelDocuments?: Array<GetOrderResponseDataTravelDocumentsInner>;
  travelDocumentsSummary?: GetOrderResponseDataTravelDocumentsSummary;
  /**
   * FP情報リスト
   */
  paymentRecords?: Array<GetOrderResponseDataPaymentRecordsInner>;
  /**
   * SK情報リスト<br/> ※配下の項目はいずれもDxAPIから返却された同名の項目をそのまま返却する。<br/> ※別APIからの内部呼び出しの場合に当項目を返却する。予約詳細画面表示時のように、当APIが外部から呼び出された場合はこの情報は返却しない。
   */
  specialKeywords?: Array<GetOrderResponseDataSpecialKeywordsInner>;
  /**
   * SSR情報リスト<br/> ※配下の項目はいずれもDxAPIから返却された同名の項目をそのまま返却する。<br/> ※SK情報リストと同様、内部呼び出しの場合にのみ当項目を返却する。
   */
  specialServiceRequests?: Array<GetOrderResponseDataSpecialServiceRequestsInner>;
  /**
   * 座席とサービス以外のEMD情報リスト<br/> ※差額払戻EMDなどが返却される。
   */
  miscAncillaries?: Array<GetOrderResponseDataMiscAncillariesInner>;

  criteoTransactionId?: string;

  anaBizTicketingRequests?: Array<AnaBizTicketingRequests>;
}

export interface AnaBizTicketingRequests {
  comment?: string;
  approver?: AnaBizTicketingRequestApprover;
  travelers?: Array<AnaBizTraveler>;
}

export interface AnaBizTicketingRequestApprover {
  id?: string;
}

export interface AnaBizTraveler {
  name?: AnaBizTravelerNameInner;
  dateOfBirth?: string;
  gender?: string;
  companyManagementCode1?: string;

  companyManagementCode2?: string;

  companyManagementCode3?: string;

  companyManagementCode4?: string;
}

export interface AnaBizTravelerNameInner {
  firstName?: string;
  lastName?: string;
  title?: string;
}

export namespace GetOrderResponseData {
  export type OrderStatusEnum =
    | 'unpurchased'
    | 'paymentAccepted'
    | 'unticketed'
    | 'ticketed'
    | 'reservationOnly'
    | 'waitlisted'
    | 'applyingForTicketing';
  export const OrderStatusEnum = {
    Unpurchased: 'unpurchased' as OrderStatusEnum,
    PaymentAccepted: 'paymentAccepted' as OrderStatusEnum,
    Unticketed: 'unticketed' as OrderStatusEnum,
    Ticketed: 'ticketed' as OrderStatusEnum,
    reservationOnly: 'reservationOnly' as OrderStatusEnum,
    waitlisted: 'waitlisted' as OrderStatusEnum,
    applyingForTicketing: 'applyingForTicketing' as OrderStatusEnum,
  };
}
